<template>
  <v-container fill-height>
    <blockquote>
      Already registered?
      <v-btn dark color="primary" class="right" @click.prevent="loginDialog = !loginDialog">Login <v-icon right>arrow_forward</v-icon></v-btn>
    </blockquote>

    <v-container>
      <h2>Get started</h2>

      <v-form v-model="newUserFormValid" ref="newUserForm">

        <div class="mb-3">
          <v-text-field name="newFirstName" id="newFirstName" required
            autocomplete="given-name"
            :label="$t('First Name')" prepend-icon="account_circle"
            v-model="newFirstName" :rules="firstNameRules"
          ></v-text-field>

          <v-text-field name="newSurname" id="newSurname" required
            autocomplete="family-name"
            :label="$t('Last Name')" prepend-icon=" "
            v-model="newSurname" :rules="lastNameRules"
          ></v-text-field>
        </div>

        <div class="mb-3">
          <v-text-field name="newEmail" id="newEmail" required
            autocomplete="email"
            :label="$t('Email')" prepend-icon="email"
            v-model="newEmail" :rules="emailRules"
          ></v-text-field>

          <v-text-field name="newRepeatEmail" id="newRepeatEmail" required
            autocomplete="email"
            :label="$t('Repeat Email')" prepend-icon=" "
            v-model="newRepeatEmail" :rules="repeatEmailRules"
          ></v-text-field>
        </div>

        <div class="mb-3">
          <v-text-field type="password" name="newPassword" required
            autocomplete="new-password"
            id="newPassword" :label="$t('Password')"  prepend-icon="security"
            v-model="newPassword" :rules="passwordRules"
          ></v-text-field>

          <v-text-field type="password" name="newRepeatPassword" required
            autocomplete="new-password"
            id="newRepeatPassword" :label="$t('Repeat Password')" prepend-icon=" "
            v-model="newRepeatPassword" :rules="repeatPasswordRules"
          ></v-text-field>
        </div>

        <v-btn dark color="primary" class="right" @click.stop="doCreate">{{ $t('Create Account') }} <v-icon right>done</v-icon></v-btn>

      </v-form>
    </v-container>

    <login-dialog :show.sync="loginDialog"></login-dialog>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import { ENQUEUE_SNACKBAR } from '@/store/mutation-types'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'
import LoginDialog from '@/components/dialogs/LoginDialog'

export default {
  name: 'RegisterPage',
  components: {
    'login-dialog': LoginDialog
  },
  data () {
    return {
      firstNameRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.FIRST_NAME')})
      ],
      lastNameRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.FAMILY_NAME')})
      ],
      emailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.EMAIL')}),
        v => /^\w+([.-]?\w+)*([+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('RULE.FIELD_INVALID_VALUE', {FIELD: this.$i18n.t('LBL.EMAIL')})
      ],
      passwordRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.PASSWORD')}),
        v => (!!v && v.length >= 4) || this.$i18n.t('RULE.FIELD_MIN_LENGTH', {FIELD: this.$i18n.t('LBL.PASSWORD'), FIELD_LEN: '4 ' + this.$i18n.t('LBL.CHARACTERS')})
      ],
      repeatEmailRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.REPEAT_EMAIL')}),
        v => v === this.newEmail || this.$i18n.t('RULE.FIELD_VALUE_MISMATCH', {FIELD: this.$i18n.t('LBL.REPEAT_EMAIL')})
      ],
      repeatPasswordRules: [
        v => !!v || this.$i18n.t('RULE.FIELD_REQUIRED', {FIELD: this.$i18n.t('LBL.REPEAT_PASSWORD')}),
        v => v === this.newPassword || this.$i18n.t('RULE.FIELD_VALUE_MISMATCH', {FIELD: this.$i18n.t('LBL.REPEAT_PASSWORD')})
      ],
      newUserFormValid: null,
      newFirstName: '',
      newSurname: '',
      newEmail: '',
      newRepeatEmail: '',
      newPassword: '',
      newRepeatPassword: '',
      loginDialog: false
    }
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 3)
  },
  methods: {
    doCreate () {
      if (this.$refs.newUserForm.validate()) {
        this.$store.dispatch('createUser', {
          email: this.newEmail,
          password: this.newPassword,
          firstname: this.newFirstName,
          lastname: this.newSurname
        })
          .then(() => {
            this.showMessage({
              text: this.$i18n.t('MSG.ACCOUNT_CREAT_SUCCESS'),
              color: 'success',
              onClose: () => {
                this.$router.push('/start')
              }
            })
          })
          .catch((error) => {
            console.log('api error', error)
            this.showMessage({
              text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
              color: 'error'
            })
          })
      }
    },
    showLoginDialog () {
      this.loginDialog = true
    },
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    })
  },
  mixins: [
    ServerErrorMixin
  ]
}
</script>

<style lang="scss" scoped>
.container {
  display: block;
}

.footer {
  height: 4em;
}

.v-center {
  top: 50%;
  transform: translateY(-50%);
}

form {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/RegisterPage.vue